module.exports = __webpack_public_path__ + "media/images/banners/bg5-8150bd69794f67741e500462881c4964.png";